// extracted by mini-css-extract-plugin
export default {"delete":"DeleteAccount_delete__jOMXK","container":"DeleteAccount_container__6eAgt","delete__warning":"DeleteAccount_delete__warning__UaSZK"};